import React from "react";

const AttachmentIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="16"
      viewBox="0 0 8 16"
      fill="none"
    >
      <path
        d="M6.90909 3.63636V12C6.90909 13.6073 5.60727 14.9091 4 14.9091C2.39273 14.9091 1.09091 13.6073 1.09091 12V2.90909C1.09091 1.90545 1.90545 1.09091 2.90909 1.09091C3.91273 1.09091 4.72727 1.90545 4.72727 2.90909V10.5455C4.72727 10.9455 4.4 11.2727 4 11.2727C3.6 11.2727 3.27273 10.9455 3.27273 10.5455V3.63636H2.18182V10.5455C2.18182 11.5491 2.99636 12.3636 4 12.3636C5.00364 12.3636 5.81818 11.5491 5.81818 10.5455V2.90909C5.81818 1.30182 4.51636 0 2.90909 0C1.30182 0 0 1.30182 0 2.90909V12C0 14.2109 1.78909 16 4 16C6.21091 16 8 14.2109 8 12V3.63636H6.90909Z"
        fill={props.active?"#0085FF":props.color}
      />
    </svg>
  );
};

export default AttachmentIcon;
